if (window.location.pathname === '/password') {
    let meta = document.createElement('meta');
    meta.name = "referrer";
    meta.content = "origin";
    document.getElementsByTagName('head')[0].appendChild(meta);
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const token = sessionStorage.getItem('activationToken');
    if (token && localStorage.getItem('cp-token') !== token) {
        localStorage.setItem("cp-token", token);
        window.location.replace("/password");
    }
}

if (window.location.href.indexOf('modalku') !== -1) {
    let metaTitle = document.createElement('meta');
    metaTitle.name = "page_og_title";
    metaTitle.content = "Modalku - Pionir Platform Peer-to-Peer (P2P) Lending";
    document.getElementsByTagName('head')[0].appendChild(metaTitle);

    let metaDescription = document.createElement('meta');
    metaDescription.name = "page_og_description";
    metaDescription.content =
      "Platform pinjaman digital berizin OJK yang menghubungkan UMKM dengan pemberi pinjaman individu & institusi di Indonesia.";
    document.getElementsByTagName('head')[0].appendChild(metaDescription);

    let fbMeta = document.createElement('meta');
    fbMeta.name = "facebook-domain-verification";
    fbMeta.content ="3h8i29cko6iyp6lxnw4ehzmud2lfge";
    document.getElementsByTagName('head')[0].appendChild(fbMeta);

} else {
    let metaTitle = document.createElement('meta');
    metaTitle.name = "page_og_title";
    metaTitle.content = "Funding Societies";
    document.getElementsByTagName('head')[0].appendChild(metaTitle);

    let metaDescription = document.createElement('meta');
    metaDescription.name = "page_og_description";
    metaDescription.content = "We are Southeast Asia's best crowdfunding platform for SME financing.";
    document.getElementsByTagName('head')[0].appendChild(metaDescription);
}
